import writeXlsxFile from "write-excel-file";
import { getList } from "../../../utils/services/gameRd";
// moment
import moment from "moment";

export async function createXlsx({
  idEvent,
  nameEvent,
  limit,
  countData,
  setFinishExport,
  getGroups,
}) {
  const formatDate = (date) => {
    const formatedDate = date.split("T")[0].split("-").reverse().join("/");
    return `${formatedDate}`;
  };
  const schema = [
    {
      column: "IDEvento",
      type: String,
      value: (participant) => idEvent,
    },
    {
      column: "NomeEvento",
      type: String,
      value: (participant) => nameEvent,
    },
    {
      column: "IDParticipante",
      type: String,
      value: (participant) => participant.login_id,
    },
    {
      column: "NomeParticipante",
      type: String,
      value: (participant) => participant.participante,
    },
    {
      column: "EmailParticipante",
      type: String,
      value: (participant) => participant.email,
    },
    {
      column: "Grupo(s)",
      type: String,
      value: (participant) =>
        getGroups(participant.grupos)
          ?.map((grp) => {
            return grp.name;
          })
          .join(", "),
    },
    {
      column: "Estande",
      type: String,
      value: (participant) => participant.description,
    },
    {
      column: "DataHora",
      type: String,
      //   value: (participant) => formatDate(participant.created_at),
      value: (participant) =>
        moment(participant.created_at).format("DD/MM/YYYY H:mm:ss"),
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getList({
      idEvent: idEvent,
      offset: 1,
      limit: limit,
      search: "",
      columnSearch: "name",
    });
    // }).then((response) => console.log(response));
    // return;
    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0,
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  const allDataInSingleArray = allRequestsPromises.map((e) => e.data).flat();
  if (allDataInSingleArray) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "GameRDNotaveis.xlsx",
    });
  }
}
